import React, { useContext } from 'react';
import { withRouter } from 'react-router';
import { Button, LocaleContext } from 'shared';

import { Header as HeaderBase, HeaderActions, HeaderTitle } from './Header.styles';
import { HeaderProps } from './Header.types';

export const Header = withRouter(({ location, userName, logoutFunction }: HeaderProps) => {
  const localeContext = useContext(LocaleContext);

  const renderHeaderTitle = () => (
    <HeaderTitle>{localeContext.formatMessage({ id: 'HEADER.ADMINISTRATION-PANEL' })}</HeaderTitle>
  );

  return (
    <HeaderBase
      active={location.pathname}
      links={[
        {
          label: localeContext.formatMessage({ id: 'SIDEBAR.API-MANAGEMENT' }),
          url: `/endpoints`,
        },
        {
          external: true,
          label: localeContext.formatMessage({ id: 'SIDEBAR.TPPS-MANAGEMENT' }),
          url: `/reports`,
        },
        {
          label: localeContext.formatMessage({ id: 'SIDEBAR.REPORTS' }),
          url: `/tpps`,
        },
      ]}
      title={renderHeaderTitle()}
    >
      {() => (
        <HeaderActions>
          <span>{userName}</span>
          <Button type="leading" onClick={logoutFunction} className="header__logout">
            {localeContext.formatMessage({ id: 'HEADER.LOGOUT' })}
          </Button>
        </HeaderActions>
      )}
    </HeaderBase>
  );
});
